import { ColorBackgroundLight, ColorBackgroundSecondaryLight, ColorBackgroundLeftRailLight, ColorBackgroundInverseLight, ColorBackgroundGrayLight, ColorBackgroundDisabledLight, ColorBackgroundCanvasLight, ColorBackgroundHighlightLight, ColorBackgroundRaisedLight, ColorBackgroundGrayEmpLight, ColorHoverLight, ColorCurtainLight, ColorBorderLight, ColorBorderDisabledLight, ColorBorderGridLight, ColorBorderDeEmpLight, ColorSelectionLight, ColorLogoLight, ColorForegroundLight, ColorForegroundEmpLight, ColorForegroundDeEmpLight, ColorForegroundDisableLight, ColorForegroundInverseLight, ColorForegroundHighlightLight, ColorForegroundHighlightSelectedLight, ColorForegroundHighlightSelectedHoverLight, ColorForegroundLinkLight, ColorForegroundLinkDisabledLight, ColorForegroundLinkPressedLight, ColorForegroundInvDeEmpLight, ColorPrimaryLight, ColorPrimaryLighterLight, ColorPrimaryHoverLight, ColorPrimaryFocusedLight, ColorPrimaryPressedLight, ColorSecondaryFocusedLight, ColorSecondaryPressedLight, ColorChipDefaultBackgroundLight, ColorChipErrorBackgroundLight, ColorChipWarningBackgroundLight, ColorChipInfoBackgroundLight, ColorChipSuccessBackgroundLight, ColorErrorIconLight, ColorErrorTextLight, ColorErrorBackgroundLight, ColorErrorForegroundInverseLight, ColorInfoForegroundLight, ColorInfoForegroundInverseLight, ColorInfoBackgroundLight, ColorSuccessIconLight, ColorSuccessTextLight, ColorSuccessBackgroundLight, ColorSuccessForegroundInverseLight, ColorWarningIconLight, ColorWarningTextLight, ColorWarningBackgroundLight, ColorWarningForegroundInverseLight, ColorIconDefaultLight, ColorIconHoverLight, ColorIconInvertedDefaultLight, ColorIconInvertedHoverLight, ColorToggleOffHoverLight, ColorToggleOffPressedLight, ColorCalloutBackgroundLight, ColorWhite, ColorPrimaryLighterDark, ColorError250, ColorError500, ColorError750, ColorGreen250, ColorGreen500, ColorGreen750, ColorWarning300, ColorWarning500, ColorWarning700, ColorBlack, ColorLightBlue300, ColorLightBlue500, ColorLightBlue700, ColorOrange100, ColorOrange200, ColorOrange300, ColorOrange400, ColorOrange500, ColorOrange600, ColorOrange700, ColorOrange800, ColorBlueSecondary100, ColorBlueSecondary200, ColorBlueSecondary300, ColorBlueSecondary400, ColorBlueSecondary500, ColorBlueSecondary600, ColorBlueSecondary700, ColorBlueSecondary800, ColorBlue100, ColorBlue200, ColorBlue300, ColorBlue400, ColorBlue500, ColorBlue600, ColorBlue700, ColorBlue800, ColorGreen100, ColorGreen200, ColorGreen300, ColorGreen400, ColorGreen600, ColorGreen700, ColorGreen800, ColorYellow100, ColorYellow200, ColorYellow300, ColorYellow400, ColorYellow500, ColorYellow600, ColorYellow700, ColorYellow800, ColorRed100, ColorRed200, ColorRed300, ColorRed400, ColorRed500, ColorRed600, ColorRed700, ColorRed800, ColorPurple100, ColorPurple200, ColorPurple300, ColorPurple400, ColorPurple500, ColorPurple600, ColorPurple700, ColorPurple800, ColorLightBlue100, ColorLightBlue200, ColorLightBlue400, ColorLightBlue600, ColorLightBlue800, ColorInk100, ColorInk150, ColorInk300, ColorInk400, ColorInk450, ColorInk550, ColorInk600, ColorInk650, ColorInk700, ColorInfo700, ColorBackgroundEditLight, ColorTileBackgroundLight, ColorForegroundLightLight, ColorPrimaryDarkerLight, } from '../_generated/Colors';
export const lightPalette = {
    type: 'light',
    semantic: {
        colorBackground: ColorBackgroundLight,
        colorBackgroundSecondary: ColorBackgroundSecondaryLight,
        colorBackgroundLeftRail: ColorBackgroundLeftRailLight,
        colorBackgroundInverse: ColorBackgroundInverseLight,
        colorBackgroundGray: ColorBackgroundGrayLight,
        colorBackgroundDisabled: ColorBackgroundDisabledLight,
        colorBackgroundEdit: ColorBackgroundEditLight,
        colorBackgroundCanvas: ColorBackgroundCanvasLight,
        colorBackgroundHigh: ColorBackgroundHighlightLight,
        colorBackgroundRaised: ColorBackgroundRaisedLight,
        colorBackgroundGrayEmp: ColorBackgroundGrayEmpLight,
        colorHover: ColorHoverLight,
        colorCurtain: ColorCurtainLight,
        colorBorder: ColorBorderLight,
        colorBorderDisabled: ColorBorderDisabledLight,
        colorBorderGrid: ColorBorderGridLight,
        colorBorderDeEmp: ColorBorderDeEmpLight,
        colorSelection: ColorSelectionLight,
        colorLogo: ColorLogoLight,
        colorForeground: ColorForegroundLight,
        colorForegroundEmp: ColorForegroundEmpLight,
        colorForegroundDeEmp: ColorForegroundDeEmpLight,
        colorForegroundDisable: ColorForegroundDisableLight,
        colorForegroundInverse: ColorForegroundInverseLight,
        colorForegroundHigh: ColorForegroundHighlightLight,
        colorForegroundHighSelected: ColorForegroundHighlightSelectedLight,
        colorForegroundHighSelectedHover: ColorForegroundHighlightSelectedHoverLight,
        colorForegroundLink: ColorForegroundLinkLight,
        colorForegroundLinkDisabled: ColorForegroundLinkDisabledLight,
        colorForegroundLinkPressed: ColorForegroundLinkPressedLight,
        colorForegroundInvDeEmp: ColorForegroundInvDeEmpLight,
        colorPrimary: ColorPrimaryLight,
        colorPrimaryLighter: ColorPrimaryLighterLight,
        colorPrimaryDarker: ColorPrimaryDarkerLight,
        colorPrimaryHover: ColorPrimaryHoverLight,
        colorPrimaryFocused: ColorPrimaryFocusedLight,
        colorPrimaryPressed: ColorPrimaryPressedLight,
        colorSecondaryFocused: ColorSecondaryFocusedLight,
        colorSecondaryPressed: ColorSecondaryPressedLight,
        colorChipDefaultBackground: ColorChipDefaultBackgroundLight,
        colorChipErrorBackground: ColorChipErrorBackgroundLight,
        colorChipWarningBackground: ColorChipWarningBackgroundLight,
        colorChipInfoBackground: ColorChipInfoBackgroundLight,
        colorChipSuccessBackground: ColorChipSuccessBackgroundLight,
        colorErrorIcon: ColorErrorIconLight,
        colorErrorText: ColorErrorTextLight,
        colorErrorBackground: ColorErrorBackgroundLight,
        colorErrorForegroundInverse: ColorErrorForegroundInverseLight,
        colorInfoForeground: ColorInfoForegroundLight,
        colorInfoForegroundInverse: ColorInfoForegroundInverseLight,
        colorInfoBackground: ColorInfoBackgroundLight,
        colorSuccessIcon: ColorSuccessIconLight,
        colorSuccessText: ColorSuccessTextLight,
        colorSuccessBackground: ColorSuccessBackgroundLight,
        colorSuccessForegroundInverse: ColorSuccessForegroundInverseLight,
        colorWarningIcon: ColorWarningIconLight,
        colorWarningText: ColorWarningTextLight,
        colorWarningBackground: ColorWarningBackgroundLight,
        colorWarningForegroundInverse: ColorWarningForegroundInverseLight,
        colorIconDefault: ColorIconDefaultLight,
        colorIconHover: ColorIconHoverLight,
        colorIconInvertedDefault: ColorIconInvertedDefaultLight,
        colorIconInvertedHover: ColorIconInvertedHoverLight,
        colorToggleOffHover: ColorToggleOffHoverLight,
        colorToggleOffPressed: ColorToggleOffPressedLight,
        colorCalloutBackground: ColorCalloutBackgroundLight,
        colorTileBackground: ColorTileBackgroundLight,
        colorForegroundLight: ColorForegroundLightLight,
    },
    primary: {
        contrastText: ColorWhite,
        light: ColorPrimaryLighterLight,
        main: ColorPrimaryLight,
        dark: ColorPrimaryLighterDark,
    },
    secondary: {
        contrastText: ColorWhite,
        light: ColorPrimaryLighterLight,
        main: ColorPrimaryLight,
        dark: ColorPrimaryLighterDark,
    },
    error: {
        contrastText: ColorWhite,
        light: ColorError250,
        main: ColorError500,
        dark: ColorError750,
    },
    success: {
        contrastText: ColorWhite,
        light: ColorGreen250,
        main: ColorGreen500,
        dark: ColorGreen750,
    },
    warning: {
        contrastText: ColorWhite,
        light: ColorWarning300,
        main: ColorWarning500,
        dark: ColorWarning700,
    },
    info: {
        contrastText: ColorBlack,
        light: ColorInfoBackgroundLight,
        main: ColorInfoForegroundLight,
        dark: ColorInfo700,
    },
    orange: {
        100: ColorOrange100,
        200: ColorOrange200,
        300: ColorOrange300,
        400: ColorOrange400,
        500: ColorOrange500,
        600: ColorOrange600,
        700: ColorOrange700,
        800: ColorOrange800,
    },
    blue: {
        100: ColorBlue100,
        200: ColorBlue200,
        300: ColorBlue300,
        400: ColorBlue400,
        500: ColorBlue500,
        600: ColorBlue600,
        700: ColorBlue700,
        800: ColorBlue800,
    },
    blue_secondary: {
        100: ColorBlueSecondary100,
        200: ColorBlueSecondary200,
        300: ColorBlueSecondary300,
        400: ColorBlueSecondary400,
        500: ColorBlueSecondary500,
        600: ColorBlueSecondary600,
        700: ColorBlueSecondary700,
        800: ColorBlueSecondary800,
    },
    green: {
        100: ColorGreen100,
        200: ColorGreen200,
        300: ColorGreen300,
        400: ColorGreen400,
        500: ColorGreen500,
        600: ColorGreen600,
        700: ColorGreen700,
        800: ColorGreen800,
    },
    yellow: {
        100: ColorYellow100,
        200: ColorYellow200,
        300: ColorYellow300,
        400: ColorYellow400,
        500: ColorYellow500,
        600: ColorYellow600,
        700: ColorYellow700,
        800: ColorYellow800,
    },
    red: {
        100: ColorRed100,
        200: ColorRed200,
        300: ColorRed300,
        400: ColorRed400,
        500: ColorRed500,
        600: ColorRed600,
        700: ColorRed700,
        800: ColorRed800,
    },
    purple: {
        100: ColorPurple100,
        200: ColorPurple200,
        300: ColorPurple300,
        400: ColorPurple400,
        500: ColorPurple500,
        600: ColorPurple600,
        700: ColorPurple700,
        800: ColorPurple800,
    },
    light_blue: {
        100: ColorLightBlue100,
        200: ColorLightBlue200,
        300: ColorLightBlue300,
        400: ColorLightBlue400,
        500: ColorLightBlue500,
        600: ColorLightBlue600,
        700: ColorLightBlue700,
        800: ColorLightBlue800,
    },
    ink: {
        100: ColorInk100,
        150: ColorInk150,
        300: ColorInk300,
        400: ColorInk400,
        450: ColorInk450,
        550: ColorInk550,
        600: ColorInk600,
        650: ColorInk650,
        700: ColorInk700,
    },
    text: {
        primary: ColorForegroundLight,
        secondary: ColorForegroundDeEmpLight,
        disabled: ColorForegroundDisableLight
    },
    divider: ColorBorderLight,
    common: {
        black: ColorBlack,
        white: ColorWhite,
    },
    icon: ColorIconDefaultLight,
    background: {
        default: ColorBackgroundLight,
        paper: ColorBackgroundLight,
    },
};
